import React from 'react';
import {TablaUserFeecback} from './TablaUserFeecback';

export const TablasUserFeedback = () => {
	return (
		<>
			<div className='tablasUserFeedback'>
				<TablaUserFeecback
					titleTabla={'Encuesta1'}
					tamHead={5}
					headTablaUserFeecback={[
						'Preguanta',
						'Nº de usuarios que han contestado',
						'Nº de usuarios que no han contestado',
						'Media de respuestas',
					]}
					contentTablaUserFeedback={[
						['Pregunta1', '100', '20', '3'],
						['Pregunta2', '134', '6', '3.5'],
						['Pregunta3', '90', '30', '4'],
						['Pregunta4', '100', '20', '3'],
						['Pregunta5', '110', '10', '3.1'],
					]}
				/>
				<TablaUserFeecback
					titleTabla={'Encuesta2'}
					tamHead={5}
					headTablaUserFeecback={[
						'Preguanta',
						'Nº de usuarios que han contestado',
						'Nº de usuarios que no han contestado',
						'Media de respuestas',
					]}
					contentTablaUserFeedback={[
						['Pregunta1', '134', '32', '5'],
						['Pregunta2', '200', '15', '4.5'],
						['Pregunta3', '343', '45', '4'],
						['Pregunta4', '220', '22', '5'],
						['Pregunta5', '176', '30', '4.9'],
					]}
				/>
			</div>
		</>
	);
};
